module.exports = __webpack_public_path__ + "img/12.48602a68.jpg";